module.exports = __webpack_public_path__ + "img/duilogo.092bc571.png";